<div class="layout-wrapper">
  <app-sidebar></app-sidebar>

  <div class="main-wrapper">
    <app-header></app-header>

    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
